import React, { useContext, useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { withRouter, useParams } from "react-router";
import { RootStoreContext } from "src/stores/RootStore";
import { NetworkConfig } from "src/network/NetworkConfig";
import { useTranslation } from "react-i18next";
import { Error } from "src/screens/error/Error";
import Axios from "src/network/Axios";

interface Params {
    fileid: string;
}

const FileBase = () => {
    const { fileid } = useParams<Params>();
    const { uiStore, uiSidebarStore } = useContext(RootStoreContext);
    const [fileUrl, setFileUrl] = useState<string | null>(null);
    const [hasError, setHasError] = useState<boolean>(false);

    const { t } = useTranslation();

    useEffect(() => {
        if (uiSidebarStore.sidebarWidth > 0) {
            uiSidebarStore.hideSidebar();
        }

        uiStore.setIsHeaderDisplayed(false);
        uiSidebarStore.setIsSidebarLogoDisplayed(false);

        return () => {
            uiSidebarStore.collapseSidebar();
            uiStore.setIsHeaderDisplayed(true);
            uiSidebarStore.setIsSidebarLogoDisplayed(true);
        };
    }, [uiSidebarStore.sidebarWidth, uiStore, uiSidebarStore, uiStore.isHeaderDisplayed]);

    useEffect(() => {
        const fetchAndOpenFile = async () => {
            try {
                const { data }: { data: Blob } = await Axios.getAuthInstance().get(
                    `${NetworkConfig.openFileWithTokenUrl}/${fileid}`,
                    {
                        urlWithoutParams: NetworkConfig.openFileWithTokenUrl,
                        responseType: "blob"
                    }
                );
                const fileURL = URL.createObjectURL(data);
                setFileUrl(fileURL);
            } catch (error) {
                console.error("Failed to load file or Error opening file:", error);
                setHasError(true);
            }
        };

        if (fileid) {
            fetchAndOpenFile();
        }

        // Cleanup the blob URL when component unmounts
        return () => {
            if (fileUrl) {
                URL.revokeObjectURL(fileUrl);
            }
        };

        // eslint-disable-next-line
    }, []);

    return (
        <div style={{ height: "100vh" }}>
            {fileUrl && !hasError && (
                <iframe
                    src={fileUrl}
                    style={{ width: "100%", height: "100%", border: "none", margin: "0px" }}
                    title="file-viewer"
                />
            )}
            {!fileUrl && !hasError && <p className="p-2">{`${t("screens.file.loading")}...`}</p>}
            {hasError && <Error message={t("screens.file.error_loading_file").toString()} />}
        </div>
    );
};

export const File = withRouter(Sentry.withProfiler(observer(FileBase)));
